export interface Category {
  name: string;
  slug: string;
  url: string;
  description: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Discover trending sneakers, running shoes, and casual footwear',
    imageSeq: 'cat-shoes-01',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Cozy hoodies, crewnecks, and knit sweaters for every season',
    imageSeq: 'cat-hoodies-02',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Essential tees, graphic prints, and premium cotton basics',
    imageSeq: 'cat-tshirts-03',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Stylish outerwear from bombers to denim and puffer jackets',
    imageSeq: 'cat-jackets-04',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Trending bottoms including cargo pants, jeans, and summer shorts',
    imageSeq: 'cat-pants-05',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps, beanies, bucket hats and more headwear accessories',
    imageSeq: 'cat-headwear-06',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Coordinated outfit sets for a complete head-to-toe look',
    imageSeq: 'cat-sets-07',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Comfortable essentials from boxers to briefs and lounge wear',
    imageSeq: 'cat-underwear-08',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Sports jerseys, team apparel, and athletic performance wear',
    imageSeq: 'cat-jersey-09',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Watches, sunglasses, jewelry, and everyday carry essentials',
    imageSeq: 'cat-accessories-10',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Backpacks, crossbody bags, totes, and travel luggage',
    imageSeq: 'cat-bags-11',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Leather belts, casual straps, and designer buckle pieces',
    imageSeq: 'cat-belts-12',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Designer fragrances, luxury scents, and everyday colognes',
    imageSeq: 'cat-perfumes-13',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Electronics, home goods, gadgets, and miscellaneous finds',
    imageSeq: 'cat-other-14',
  },
];